export const CC_LICENSES = [
  {
    value: 'Creative Commons Attribution 4.0 International',
    url: 'https://creativecommons.org/licenses/by/4.0/legalcode',
  },
  {
    value: 'Creative Commons Attribution-ShareAlike 4.0 International',
    url: 'https://creativecommons.org/licenses/by-sa/4.0/legalcode',
  },
  {
    value: 'Creative Commons Attribution-NoDerivatives 4.0 International',
    url: 'https://creativecommons.org/licenses/by-nd/4.0/legalcode',
  },
  {
    value: 'Creative Commons Attribution-NonCommercial 4.0 International',
    url: 'https://creativecommons.org/licenses/by-nc/4.0/legalcode',
  },
  {
    value: 'Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International',
    url: 'https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode',
  },
  {
    value: 'Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International',
    url: 'https://creativecommons.org/licenses/by-nc-nd/4.0/legalcode',
  },
];
export const LEGACY_CC_LICENSES = [
  {
    value: 'Creative Commons Attribution 3.0',
    url: 'https://creativecommons.org/licenses/by/3.0/legalcode',
  },
];
export const NONE = 'None';
export const PUBLIC_DOMAIN = 'Public Domain';
export const OTHER = 'other';
export const COPYRIGHT = 'copyright';
